"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/utils/utils";
import type { GettingStartedTask } from "@/constants/getting-started";
import { JurniCoreInfo } from "./jurni-core-info";

export interface GettingStartedTaskStatus {
  completed: boolean;
  dismissed: boolean;
  dismissible: boolean;
  showJurniCoreWarning: boolean;
}

interface Props {
  task: GettingStartedTask;
  status?: GettingStartedTaskStatus;
  onClick: () => void;
  onDismiss: () => void;
}

export const GettingStartedTaskRow = ({
  task,
  status,
  onClick,
  onDismiss,
}: Props) => {
  const isDone = !!(status?.completed || status?.dismissed);
  const Icon = task.icon;

  return (
    <div
      className="group flex h-8 w-full cursor-pointer items-center justify-between rounded-md px-2 hover:bg-foreground/5"
      onClick={onClick}
    >
      <span className="flex min-w-0 items-center gap-2 text-[13px] leading-[normal] tracking-[-0.13px]">
        <Icon
          size={14}
          strokeWidth={2}
          className={cn(
            "shrink-0",
            isDone ? "text-muted-foreground/60" : "text-muted-foreground",
          )}
        />
        <span
          className={cn(
            "truncate",
            isDone
              ? "text-muted-foreground/60 line-through"
              : "text-foreground",
          )}
        >
          {task.label}
        </span>
        {status?.showJurniCoreWarning && <JurniCoreInfo />}
      </span>
      <div className="flex items-center gap-2">
        {!isDone && status?.dismissible !== false && (
          <Button
            variant="outline"
            type="button"
            size="xs"
            onClick={(event) => {
              event.stopPropagation();
              onDismiss();
            }}
            className="invisible h-5 w-fit rounded-md px-1.5 shadow-none group-hover:visible"
          >
            <span className="whitespace-nowrap text-[11px] leading-[normal]">
              Dismiss
            </span>
          </Button>
        )}
        <ArrowRight
          size={13}
          strokeWidth={2}
          className="shrink-0 text-muted-foreground opacity-0 transition-opacity duration-75 group-hover:opacity-100"
        />
      </div>
    </div>
  );
};
